import { render, staticRenderFns } from "./shoreSightseeSwiper.vue?vue&type=template&id=8beea584&scoped=true"
import script from "./shoreSightseeSwiper.vue?vue&type=script&lang=js"
export * from "./shoreSightseeSwiper.vue?vue&type=script&lang=js"
import style0 from "./shoreSightseeSwiper.vue?vue&type=style&index=0&id=8beea584&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beea584",
  null
  
)

export default component.exports